/** Client signup URL that prefills facilitatorRef and auto-links on register. */
export function buildFacilitatorClientSignupUrl(
  referenceId: string,
  origin: string = typeof window !== "undefined" ? window.location.origin : "",
): string {
  const trimmed = referenceId.trim().toUpperCase();
  const url = new URL("/signup", origin || "http://localhost");
  url.searchParams.set("facilitatorRef", trimmed);
  return url.toString();
}
